import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from 'react-redux';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

import { transactionsTypes } from 'companion-app-components/flux/transactions';
import type RootState from 'companion-app-components/utils/redux-store/rootState';
import { featureFlagsSelectors } from 'companion-app-components/flux/feature-flags';

import { isC2RTransaction } from 'data/transactions/utils';
import QTypography from 'components/MUIWrappers/QTypography';

import { RegListItem, styles } from '../styles';

import CheckOptionPicker from './CheckOptionPicker';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface CheckFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  wrapClass: string; 
  editClass: string; 
  hoverClass: string;
  currEditFieldName: string;
  enableAutoFocus: boolean;
  staticValue?: string | React.JSX.Element | null;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const CheckField: FC<CheckFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  editable,
  SHOW_ALL,
  txn,
  wrapClass, 
  editClass, 
  hoverClass,
  currEditFieldName,
  enableAutoFocus,
  staticValue,
  focusField,
}) => {
  const { classes, theme } = useStyles();

  const showCheckSuggestions = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlag(state, 'showCheckSuggestions'));

  const c2RTxnClass = isC2RTransaction(txn) ? classes.txnInC2RText : '';
  return (
    <RegListItem
      {...attributes}
      className={classNames(classes.regItem, wrapClass, editClass, hoverClass, c2RTxnClass)}
    >
      {SHOW_ALL &&
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {editable && !forceStatic && currEditFieldName === 'check' ?
          <TextField
            InputProps={{
              // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
              disableUnderline: theme.mixins?.register.noUnderline,
              endAdornment: 
                showCheckSuggestions ? 
                  <InputAdornment position="end">
                    <CheckOptionPicker 
                      onSelect={(option) => callbacks.handleChange?.({ target: { value: option } }, 'check')}
                    />
                  </InputAdornment> : null,
            }}
            className={classes.regInput}
            onFocus={callbacks.handleFocus}
            placeholder="Check #"
            autoFocus={enableAutoFocus}
            value={(txn.check && (txn.check.number || txn.check.memo)) || ''}
            onChange={(e) => callbacks.handleChange?.(e, 'check')}
            inputRef={(input) => {
              focusField.current = input; // eslint-disable-line
            }}
            autoComplete="off"
          >
          </TextField> :
          <QTypography
            clickable={!forceStatic ? 'true' : null}
            thinFont
            className={classes.regItemCore}
          >
            {staticValue}
          </QTypography>}
      </>}
    </RegListItem>
  );
};

export default CheckField;
